'use client'
import useStopFilterManager from '@/src/hooks/srp/stopFilterManager'
import React from 'react'
import StopsFilter from './StopsFilter'

const StopsFilterWrapper = React.memo(() => {
    const { stopOptions, stopReset, stopToggle, shouldShowReset, title } = useStopFilterManager()

    return (
        <StopsFilter
            stopOptions={stopOptions}
            onOptionClick={stopToggle}
            onStopsReset={stopReset}
            shouldShowReset={shouldShowReset}
            title={title}
        />
    )
})

StopsFilterWrapper.displayName = 'StopsFilterWrapper'

export { StopsFilterWrapper }
export default StopsFilterWrapper
